export default "__VITE_ASSET__b96a0917__"